export enum FreightDocumentStatus {
  DRAFT = 'DRAFT',
  ISSUED = 'ISSUED',
  TRANSIT = 'TRANSIT',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
}
